/**
 * Created by Daniela on 23/01/2017.
 */
import { NgModule } from '@angular/core';

import { TanquesComponent } from './tanques.component';
import { SharedModule } from "../../shared/shared.module";
import { TanqueApiService } from "./shared/tanque-api.service";
import { TanqueNavigationService } from "./shared/tanque-navigation.service";
import { TanqueService } from "./shared/tanque.service";
import { TanquesRoutingModule } from "./tanques-routing.module";
import { TanqueFormComponent } from "./tanque-form/tanque-form.component";
import { TanqueListComponent } from "./tanque-list/tanque-list.component";
import { TanqueEstoqueListComponent } from "./tanque-estoque-list/tanque-estoque-list.component";
import { TanqueMovimentacaoDetailComponent } from "./tanque-movimentacao-detail/tanque-movimentacao-detail.component";
import { TanqueMovimentacaoFormComponent } from "./tanque-movimentacao-form/tanque-movimentacao-form.component";
import { TanqueMovimentacaoAreaFormComponent } from "./tanque-movimentacao-area-form/tanque-movimentacao-area-form.component";

@NgModule({
    imports: [
        SharedModule,
        TanquesRoutingModule
    ],
    providers: [
        TanqueApiService,
        TanqueNavigationService,
        TanqueService
    ],
    declarations: [
        TanquesComponent,
        TanqueFormComponent,
        TanqueListComponent,
        TanqueEstoqueListComponent,
        TanqueMovimentacaoDetailComponent,
        TanqueMovimentacaoFormComponent,
        TanqueMovimentacaoAreaFormComponent
    ],
    exports: [
        TanqueMovimentacaoAreaFormComponent
    ]
})
export class TanquesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanques.module.ts
 **/